/** Emergency services UI icons (KEEP IN SYNC with mobile EmergencyServiceIcons.js) */
export const EMERGENCY_ICON_COLOR = "#FFFFFF";

/** White handset for use on dark circular buttons (matches callLeft.svg). */
export function EmergencyPhoneIcon({ size = 20, color = EMERGENCY_ICON_COLOR }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M13.6745 16.46C13.3144 15.7178 12.8489 15.1776 12.0452 15.507L10.4598 16.0954C9.1906 16.6839 8.55819 16.0954 7.9214 15.2083L5.06679 8.7174C4.70667 7.9752 4.89552 7.27692 5.6992 6.94754L7.917 6.06042C8.72068 5.72665 8.59333 5.03277 8.23321 4.29057L6.34038 0.750861C5.98027 0.00866465 5.24246 -0.171395 4.43878 0.157982C2.82703 0.821128 1.49634 1.86196 0.635572 3.40345C-0.418435 5.28748 0.108569 7.90933 0.31937 9.01164C0.530172 10.114 1.26798 12.0463 2.22097 14.027C3.17397 16.012 4.00839 17.5711 4.75937 18.4538C5.50596 19.3365 7.29777 21.752 9.51558 22.2921C11.3337 22.7313 13.2968 22.3624 14.9042 21.6993C15.7079 21.3699 15.7123 20.6716 15.3521 19.925L13.6745 16.46Z"
        fill={color}
      />
    </svg>
  );
}

export function PoliceServiceIcon({ size = 112, color = EMERGENCY_ICON_COLOR }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 2.18 7 3.11v5.71c0 4.54-3.07 8.86-7 9.93-3.93-1.07-7-5.39-7-9.93V6.29l7-3.11z" />
      <path
        d="M12 7.5a2.5 2.5 0 0 0-2.5 2.5v1.25a2.5 2.5 0 0 0 5 0V10A2.5 2.5 0 0 0 12 7.5z"
        fill="#D88284"
      />
    </svg>
  );
}

export function MedicalServiceIcon({ size = 112, color = EMERGENCY_ICON_COLOR }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
      <path d="M11 8h2v3h3v2h-3v3h-2v-3H8v-2h3V8z" fill="#D88284" />
    </svg>
  );
}

/** Phone in dark circle � list cards on Police/Medical services pages. */
export function EmergencyPhoneBadge({
  circleColor = "#8E264E",
  iconSize = 20,
  className = "",
}) {
  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-full w-10 h-10 ${className}`}
      style={{ backgroundColor: circleColor }}
      aria-hidden="true"
    >
      <EmergencyPhoneIcon size={iconSize} />
    </div>
  );
}
